import itemsStore from '~/view/screens/MenuManagementScreen/screens/ItemsScreen/store/itemsStore';

export const addItemInStore = async (itemId: number) => {
  if (itemId && itemsStore.item?.id) {
    return;
  }

  if (itemId && itemsStore.pagination.data.length > 0) {
    itemsStore.setItem(itemsStore.pagination.data.find((item) => item.id === itemId));
  }

  if (itemId && itemsStore.item?.id) {
    return;
  }

  if (!itemsStore.item?.id) {
    await itemsStore.getItem(itemId);

    if (itemsStore.item?.id) {
      return;
    }
  }

  itemsStore.setItem();
};
